import { useState, useCallback } from "react";
import {
  Box,
  Button,
  Typography,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  LinearProgress,
  Grid,
} from "@material-ui/core";

import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import MaskAndValid from "utils/maskAndValid";
import Api from "lib/api/httpRequestHelper";
import { IsMobile } from "utils/is-mobile";
import PasswordField from "components/_refactor/fields/password";

const DialogChangePassword = ({ open, handleClose }) => {
  const [loading, setLoading] = useState(false);
  const snackbar = useSnackbar();
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmationPassword, setConfirmationPassword] = useState("");
  const [passwordIsOk, setPasswordIsOk] = useState(false);

  const isMobile = IsMobile();

  const submit = useCallback(async () => {
    setLoading(true);

    await Api.post(
      "change-password",
      "login",
      { senhaAtual: currentPassword, senhaNova: newPassword },
      true
    )
      .then((res) => {
        if (res?.Result?.Trocou) {
          snackbar.showMessage("Senha alterada com sucesso!", {
            severity: "success",
          });
          handleClose();
        } else {
          snackbar.showMessage(
            "Ocorreu um erro ao alterar sua senha. Verifique os parâmetros informados.",
            {
              severity: "error",
            }
          );
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        if (
          error === "HTTPERRO 422 A senhaAtual não está correta. Verifique."
        ) {
          snackbar.showMessage("Senha atual não está correta. Verifique.", {
            severity: "error",
          });
        } else {
          snackbar.showMessage(
            "Ocorreu um erro ao alterar sua senha. Verifique os parâmetros informados.",
            {
              severity: "error",
            }
          );
        }
        setLoading(false);
      });
  }, [snackbar, handleClose, currentPassword, newPassword]);

  return (
    <>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>
          <Typography id="alert-dialog-title" variant="h3" component="h3">
            Alterar senha
          </Typography>
        </DialogTitle>
        <form onSubmit={submit}>
          <DialogContent style={{ padding: "0 1.5rem 1.5rem" }}>
            <Typography id="alert-dialog-description" variant="h4">
              Preencha a senha atual e a nova de acordo com os critérios de
              senha
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <PasswordField
                  label="Senha Atual"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <PasswordField
                  label="Nova Senha"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  strengthInfo
                  required
                />
              </Grid>
              <Grid item xs={12}>
                <PasswordField
                  label="Confirmação da Nova Senha"
                  value={confirmationPassword}
                  onChange={(e) => setConfirmationPassword(e.target.value)}
                  confirmPassword={newPassword}
                  setPasswordIsOk={setPasswordIsOk}
                  required
                />
              </Grid>
            </Grid>
            {loading && (
              <div style={{ marginTop: "1rem" }}>
                <span>Alterando senha...</span>
                <LinearProgress />
              </div>
            )}
          </DialogContent>
          <DialogActions>
            <Grid
              item
              xs={isMobile && 12}
              style={
                isMobile
                  ? { marginBottom: "1rem", marginTop: "-2rem" }
                  : { marginTop: "0" }
              }
            >
              <Button
                fullWidth
                component={Box}
                onClick={handleClose}
                disabled={loading}
              >
                Cancelar
              </Button>
            </Grid>
            <Grid item xs={isMobile && 12}>
              <Button
                fullWidth
                component={Box}
                variant="contained"
                type="submit"
                onClick={submit}
                disabled={
                  loading ||
                  !passwordIsOk ||
                  MaskAndValid.isNullOrEmpty(currentPassword) ||
                  MaskAndValid.isNullOrEmpty(newPassword) ||
                  MaskAndValid.isNullOrEmpty(confirmationPassword) ||
                  !(
                    newPassword?.length &&
                    confirmationPassword?.length &&
                    newPassword === confirmationPassword
                  )
                }
                color="default"
              >
                Confirmar
              </Button>
            </Grid>
          </DialogActions>
        </form>
      </Dialog>
    </>
  );
};

export default DialogChangePassword;
